/* eslint-disable import/extensions */
import { blockEmployeeReducer } from '@reducers/block-employee-slice';
import { feedbackReducer } from '@reducers/feedback-slice';
import { robotoCallReducer } from '@reducers/roboto-call-slice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import { aiAgentReducer } from 'modules/ai-agent/store';
import { companyRealtorReducer } from 'modules/company-realtor';
import { dashboardReducer } from 'modules/dashboard-v2';
import { offerReducer } from 'modules/offer';
import { realtorFlatReducer } from 'modules/realtor/flat';
import { realtorOfferReducer } from 'modules/realtor/offer';
import { realtorSearchReducer } from 'modules/realtor/search';
import { realtorBookingReducer } from 'modules/realtor-booking';
import { taskReducer } from 'modules/task';

import allHouseFilter from './reducers/AllHouseFilter';
import bossCurrency from './reducers/BossCurrencySlice';
import changesReducer from './reducers/ChangesSlice';
import clientReducer from './reducers/ClientSlice';
import companiesReducer from './reducers/CompaniesSlice';
import companyEmployeesReducer from './reducers/CompanyEmployeesSlice';
import companyReducer from './reducers/CompanySlice';
import contractReducer from './reducers/ContractSlice';
import createContract from './reducers/CreateContractSlice';
import createContractV2 from './reducers/CreateContractSliceV2';
import crmField from './reducers/CrmFieldSlice';
import crmOneLidField from './reducers/CrmOneLidSlice';
import assigmentSlice from './reducers/CrmSlice';
import crmStatistic from './reducers/CrmStatisticsSlice';
// eslint-disable-next-line import/no-named-as-default
import crmV2Slice from './reducers/CrmV2Slice';
import currency from './reducers/CurrencySlice';
import debtSlice from './reducers/DebtSlice';
import flatReducer from './reducers/FlatSlice';
import googleDocViewer from './reducers/GoogleDocVieweSlice';
import houseHistorySlice from './reducers/house-history-slice';
import houseConfigReducer from './reducers/HouseConfigSlice';
import houseReducer from './reducers/HouseSlice';
// eslint-disable-next-line import/no-named-as-default
import ioServiceSlice from './reducers/IOServiceSlice';
import monthlyPaymentsReducer from './reducers/MonthlyPaymentsSlice';
// eslint-disable-next-line import/no-named-as-default
import notificationSlice from './reducers/notificationSlice';
// eslint-disable-next-line import/no-named-as-default
import notTaskLeadNotification from './reducers/NotTaskLeadNotificationSlice';
// eslint-disable-next-line import/no-named-as-default
import qrCodeModeSlice from './reducers/QrCodeModeSlice';
import sendMessageCrmSlice from './reducers/SendMessageCrmSlice';
import shaxmatkaReducer from './reducers/ShaxmatkaSlice';
import shaxmatkaV3 from './reducers/ShaxmatkaV3Slice';
import showroomModal from './reducers/ShowroomModalSlice';
import showroomSlice from './reducers/ShowroomSlice';
// eslint-disable-next-line import/no-named-as-default
import taskCalendarViewSlice from './reducers/TaskCalendarViewSlice';
// eslint-disable-next-line import/no-named-as-default
import taskChangeTextSlice from './reducers/TaskChangetextSlice';
import textEditorReducer from './reducers/TextEditorSlice';
import transferDataReducer from './reducers/TransferDataSlice';
// eslint-disable-next-line import/no-named-as-default
import triggerSlice from './reducers/TriggerSlice';
import userReducer from './reducers/UserSlice';
import webRTCReducer from './reducers/WebRTCSlice';
import websiteUserReducer from './reducers/WebsiteUserSlice';

const rootReducer = combineReducers({
  shaxmatkaV3,
  showroomModal,
  userReducer,
  houseReducer,
  clientReducer,
  flatReducer,
  monthlyPaymentsReducer,
  houseConfigReducer,
  shaxmatkaReducer,
  contractReducer,
  transferDataReducer,
  companiesReducer,
  websiteUserReducer,
  companyEmployeesReducer,
  changesReducer,
  allHouseFilter,
  assigmentSlice,
  crmField,
  crmOneLidField,
  notificationSlice,
  sendMessageCrmSlice,
  triggerSlice,
  crmStatistic,
  taskCalendarViewSlice,
  createContract,
  currency,
  googleDocViewer,
  notTaskLeadNotification,
  bossCurrency,
  companyReducer,
  webRTCReducer,
  textEditorReducer,
  showroomSlice,
  debtSlice,
  qrCodeModeSlice,
  taskChangeTextSlice,
  ioServiceSlice,
  houseHistorySlice,
  crmV2Slice,
  dashboardReducer,
  createContractV2,
  taskReducer,
  offerReducer,
  realtorOfferReducer,
  realtorBookingReducer,
  companyRealtorReducer,
  realtorFlatReducer,
  robotoCallReducer,
  feedbackReducer,
  blockEmployeeReducer,
  realtorSearchReducer,
  aiAgentReducer
});

const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false
      })
  });

export const store = setupStore();

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
